var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":"rtl"}},[(_vm.$route.meta.DashboardLayout)?_c('div',{},[_c('LayoutContent')],1):_c('div',[_c('LayoutBlank')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }